module.exports = __webpack_public_path__ + "img/feedbacks.4a2fea3b.png";